import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { EnrollmentConfirmComponent } from './enrollment-confirm/enrollment-confirm.component';
import { MatDialog } from '@angular/material';
import { APP_ACTIONS, PAGE_STATE } from './app-constants';
const RETIREMENT_PATH = '/retirement-planner/';
const PLANNER_PATH = '/life-goal-planner/';
const EDUCATION_PLANNER = '/education-planner/';
const SPECIAL_EVENTS = '/special-events/';
const ENDOWMENT = '/endowments-planning/';
@Injectable({
  providedIn: 'root'
})
export class AppNavigationService {
  lifeGoalType: any;
  basePath: any;
  private canGoNext = false;
  private ACTIONS = APP_ACTIONS;
  _pageState: any[] = PAGE_STATE;
   plannerType: any;
  constructor(private router: Router, private dialog: MatDialog,
    private cookieService: CookieService) {
    this.lifeGoalType = this.cookieService.get('appType') ? JSON.parse(this.cookieService.get('appType')).appName : 0;
    this.plannerType = this.cookieService.get('plannerType') ? this.cookieService.get('plannerType') : 0;
    if (this.lifeGoalType && this.lifeGoalType.toLowerCase() === 'retirement') {
      this.basePath = RETIREMENT_PATH;
    } else if (this.lifeGoalType && this.lifeGoalType === 'educationSales' && this.plannerType && this.plannerType === 'StraightShooter') {
      this.basePath = EDUCATION_PLANNER;
    } else if (this.lifeGoalType && this.lifeGoalType === 'specialEvents' && this.plannerType && this.plannerType === 'StraightShooter') {
      this.basePath = SPECIAL_EVENTS;
    } else if (this.plannerType && JSON.parse(this.plannerType) === 'Endowment') {
      this.basePath = ENDOWMENT;
    } else {
      this.basePath = PLANNER_PATH;
    }
  }
  navigate(action: string) {
    if (this.ACTIONS[action] === -1) {
      this.goBack();
    } else if (this.ACTIONS[action] === 1) {
      if (this.router.url !== '/finalize') {
        this.canGoNext = false;
      }
      this.goForward();
    } else {
      return;
    }
  }
  private goBack() {
    const currentState = this.findState(this.router.url);
    console.log('Current State', currentState);

    let backName = '';
    if (this.lifeGoalType && currentState) {
      if (this.lifeGoalType === 'retirement' && currentState.currentUrl.includes('payment')) {
        backName = currentState.retirementBackName;
      } else {
        backName = currentState.backName;
      }
    }

    currentState ? this.openBackConfirmationDialog(currentState, currentState.name, backName) :
      window.location.href = '/mmih-cdi-portfolio-client/portfolio/';
  }
  private goForward() {
    const currentState = this.findState(this.router.url);
    this.router.navigateByUrl(currentState.nextUrl);
    this.canGoNext = false;
  }
  setCanGoNext(canGoNext: boolean): void {
    this.canGoNext = canGoNext;
  }
  isCanGoNext() {
    return this.canGoNext;
  }
  openBackConfirmationDialog(currentState: any, moduleName: string, previousModuleName: string) {
    this.dialog.open(EnrollmentConfirmComponent, {
      data: {
        basePath: this.basePath,
        backName: previousModuleName,
        currentState: currentState,
        name: moduleName,
        lifeGoalType: this.lifeGoalType,
        router: this.router,
        dialog: this.dialog,
        cookieService: this.cookieService,
        plannerType: this.plannerType
      }
    });
  }

  redirectToMethub() {
    this.cookieService.delete('plan', '/');
    this.cookieService.delete('appType', '/');
    this.cookieService.delete('plan', '/', window.location.hostname);
    this.cookieService.delete('appType', '/', window.location.hostname);
    this.cookieService.delete('lifeCompetent', '/', window.location.hostname);
    this.cookieService.delete('life', '/', window.location.hostname);
    this.cookieService.delete('loanCompetent', '/', window.location.hostname);
    this.cookieService.delete('loan', '/', window.location.hostname);
    this.cookieService.delete('serviceCompetent', '/', window.location.hostname);
    this.cookieService.delete('service', '/', window.location.hostname);
    this.cookieService.delete('api_version', '/', window.location.hostname);
    this.cookieService.delete('planSummary', '/', window.location.hostname);
    this.cookieService.delete('planSummaryCompetent', '/', window.location.hostname);
    this.cookieService.delete('retirement', '/', window.location.hostname);
    this.cookieService.delete('retirementCompetent', '/', window.location.hostname);
    this.deleteServicingCookies();
    window.location.href = '/methub/';
  }

  redirectToSearch() {
    this.cookieService.delete('client', '/', window.location.hostname);
    this.cookieService.delete('client', '/');
    this.cookieService.delete('plan', '/');
    this.cookieService.delete('appType', '/');
    this.cookieService.delete('plan', '/', window.location.hostname);
    this.cookieService.delete('appType', '/', window.location.hostname);
    this.cookieService.delete('lifeCompetent', '/', window.location.hostname);
    this.cookieService.delete('life', '/', window.location.hostname);
    this.cookieService.delete('loanCompetent', '/', window.location.hostname);
    this.cookieService.delete('loan', '/', window.location.hostname);
    this.cookieService.delete('serviceCompetent', '/', window.location.hostname);
    this.cookieService.delete('service', '/', window.location.hostname);
    this.cookieService.delete('api_version', '/', window.location.hostname);
    this.cookieService.delete('planSummary', '/', window.location.hostname);
    this.cookieService.delete('planSummaryCompetent', '/', window.location.hostname);
    this.cookieService.delete('retirement', '/', window.location.hostname);
    this.cookieService.delete('retirementCompetent', '/', window.location.hostname);
    this.cookieService.delete('plannerType', '/', window.location.hostname);
    this.deleteServicingCookies();
    window.location.href = '/mmih-cdi-search-client/';
  }

  redirectToWellnessWheel() {
    this.cookieService.delete('plan', '/', window.location.hostname);
    this.cookieService.delete('appType', '/', window.location.hostname);
    this.cookieService.delete('lifeCompetent', '/', window.location.hostname);
    this.cookieService.delete('life', '/', window.location.hostname);
    this.cookieService.delete('loanCompetent', '/', window.location.hostname);
    this.cookieService.delete('loan', '/', window.location.hostname);
    this.cookieService.delete('serviceCompetent', '/', window.location.hostname);
    this.cookieService.delete('service', '/', window.location.hostname);
    this.cookieService.delete('api_version', '/', window.location.hostname);
    this.cookieService.delete('planSummary', '/', window.location.hostname);
    this.cookieService.delete('planSummaryCompetent', '/', window.location.hostname);
    this.cookieService.delete('retirement', '/', window.location.hostname);
    this.cookieService.delete('retirementCompetent', '/', window.location.hostname);
    this.cookieService.delete('plannerType', '/', window.location.hostname);
    this.deleteServicingCookies();
    window.location.href = '/mmih-cdi-portfolio-client/portfolio/';
  }

  private deleteServicingCookies(): void {
    this.cookieService.delete('serviceCompetent', '/', window.location.hostname);
    this.cookieService.delete('service', '/', window.location.hostname);
    this.cookieService.delete('coolOff', '/', window.location.hostname);
    this.cookieService.delete('coolOffCompetent', '/', window.location.hostname);
    this.cookieService.delete('fullWithdrawal', '/', window.location.hostname);
    this.cookieService.delete('fullWithdrawalCompetent', '/', window.location.hostname);
    this.cookieService.delete('recurring', '/', window.location.hostname);
    this.cookieService.delete('recurringCompetent', '/', window.location.hostname);
    this.cookieService.delete('planSummaryCompetent', '/', window.location.hostname);
    this.cookieService.delete('planSummary', '/', window.location.hostname);
    this.cookieService.delete('partialWithdrawalCompetent', '/', window.location.hostname);
    this.cookieService.delete('partialWithdrawal', '/', window.location.hostname);
    this.cookieService.delete('isChangeRecurringPaymentDetailsCompetent', '/', window.location.hostname);
    this.cookieService.delete('changeRecurringPaymentDetails', '/', window.location.hostname);
    this.cookieService.delete('isChangeRecurringPaymentAmountCompetent', '/', window.location.hostname);
    this.cookieService.delete('changeRecurringPaymentAmount', '/', window.location.hostname);
    this.cookieService.delete('isChangeRecurringVPBCompetent', '/', window.location.hostname);
    this.cookieService.delete('changeRecurringVPB', '/', window.location.hostname);
    this.cookieService.delete('onceOffPaymentCompetent', '/', window.location.hostname);
    this.cookieService.delete('onceOffPayment', '/', window.location.hostname);
  }

  private findState(url: string) {
    return this._pageState.find(page => page.currentUrl === url);
  }
}
